import React from 'react';
import { Decision } from '../../entity/entity.types';
import { fetchLawFirmTopDecisions } from '../lawFirm.api';
import { EntityTopDecisions } from '../../entity/top-decisions/EntityTopDecisions';

type Props = {
  lawOfficeIdGroup: string;
  decisionCount: number;
  allDecisionsLink: string;
  firmName: string;
};

type State = {
  decisions: Array<Decision>;
};

export class FirmTopDecisions extends React.Component<Props, State> {
  state: State = {
    decisions: [],
  };

  async componentDidMount() {
    const decisions = (
      await fetchLawFirmTopDecisions(this.props.lawOfficeIdGroup)
    ).data.arrets;
    this.setState({ decisions });
  }

  render() {
    const { allDecisionsLink, decisionCount, firmName } = this.props;
    const { decisions } = this.state;

    if (decisions.length === 0) {
      return null;
    }

    return (
      <EntityTopDecisions
        decisions={decisions}
        entityType="lawFirm"
        sources={{
          allDecisionsLink: 'read_all_law_firm_decisions_from_top_decisions',
          decisionLink: 'lawFirm_top_decision',
        }}
        allDecisionLink={allDecisionsLink}
        decisionCount={decisionCount}
        entityName={firmName}
      />
    );
  }
}
